import config from '@app/config';
import { type EmojiWasm, WasmType } from '@app/store/types/emoji';

export async function importEmojiWasm<T = EmojiWasm>(wasmType?: WasmType): Promise<T | undefined> {
    try {
        let emojiModule;

        if (wasmType && wasmType === WasmType.EmojiAdminWasm) {
            emojiModule = await import(`@tari-labs/emojis-wasm-admin`);
        } else {
            emojiModule = await import(`@tari-labs/emojis-wasm-default`);
        }
        if (config.nodeEnv === 'development') {
            emojiModule.init_debug();
        }
        return emojiModule;
    } catch (error) {
        // Should we return an explicit error?
        return undefined;
    }
}
